import React from "react";
import { Link } from "react-router-dom";
import { BsArrowRightShort } from "react-icons/bs";
import { useNavContext } from "../../context-api/nav-context";
/* import boilerInstall from "../../Assets/Images/homeServices/boiler4.svg";
import boilerService from "../../Assets/Images/homeServices/boiler-service.png";
import plumbing from "../../Assets/Images/homeServices/bath1.png";
import thermostat from "../../Assets/Images/homeServices/thermostat.png"; */

const HomeServices = () => {
  const { closeNavbarMenu } = useNavContext();
  return (
    <section className="home-services" onMouseOver={closeNavbarMenu}>
      <div className="home-services_box home-services_box_boiler">
        <div className="box-content-boiler">
          <img
            src="https://res.cloudinary.com/duwmjod0j/image/upload/q_80/v1642185411/AquaHeat/Home%20Services/boiler4_wvzax9.webp"
            alt="New Boiler Installation Services"
          />
          <h3 className="home-services_box_title">Boilers</h3>
          <Link to="/boilers" className="btn-hero btn-quote">
            Find Out More <BsArrowRightShort class="btn-arrow" />
          </Link>
        </div>
      </div>
      <div className="home-services_box home-services_box_repairs">
        <div className="box-content-service">
          <img
            src="https://res.cloudinary.com/duwmjod0j/image/upload/q_80/v1642185412/AquaHeat/Home%20Services/boiler-service_ovthwe.webp"
            className="service-img"
            alt=""
          />
          <h3 className="home-services_box_title">Servicing</h3>
          <Link to="/boiler-service" className="btn-hero btn-quote">
            Find Out More <BsArrowRightShort class="btn-arrow" />
          </Link>
        </div>
      </div>
      <div className="home-services_box home-services_box_plumbing">
        <div className="box-content-plumbing">
          <img
            src="https://res.cloudinary.com/duwmjod0j/image/upload/q_80/v1642185411/AquaHeat/Home%20Services/bath1_n8ygfl.webp"
            className="plumbing-img"
            alt=""
          />
          <h3 className="home-services_box_title">Plumbing</h3>
          <Link to="/plumbing" className="btn-hero btn-quote">
            Find Out More <BsArrowRightShort class="btn-arrow" />
          </Link>
        </div>
      </div>
      <div className="home-services_box home-services_box_boilercover">
        <div className="box-content-boilercover">
          <img
            src="https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_600/v1642185411/AquaHeat/Home%20Services/thermostat_dazuoo.webp"
            className="plumbing-img extra"
            alt=""
          />
          <h3 className="home-services_box_title">Boiler Cover</h3>
          <Link to="/coming-soon" className="btn-hero btn-quote">
            Find Out More <BsArrowRightShort class="btn-arrow" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HomeServices;
